import React, { useState } from "react";
import IconBox from "../shared/IconBox";
import mines from "../../assets/img/icons/Vector.svg";
import add from "../../assets/img/icons/add.svg";
const CounterWithlabelin = ({ className, abs, count,label, setCount,labelin }) => {
  const increase = () => {
    setCount(prev => (prev += 1));
  };
  const decrease = () => {
    if (count > 0) {
      setCount(prev => (prev -= 1));
    }
  };
  return (
    <div className="CounterWithlabelin">
 <h6>{label}</h6>
      <div
        className="CounterWithlabelin--count"
        onClick={e => e.stopPropagation()}
      >
     
        <div className="CounterWithlabelin__container flex justify-between items-center">
        {setCount !== null ?  <IconBox
            onClick={increase}
            white
            className="CounterWithlabelin__iconbox"
          >
            <img alt='' width={24} src={add} />
          </IconBox> : <div width={20}></div>}
          <div className="CountWithlabelin__count text-center">{count}</div>
        { setCount !== null?  <IconBox
            onClick={decrease}
            white
            className="CounterWithlabelin__iconbox"
          >
            <img alt='' width={12} src={mines} />
          </IconBox>: <div width={20}></div>}
        </div>
        <div className="CounterWithlabelin__labelin"> {labelin}</div>
      </div>
    </div>
  );
};

export default CounterWithlabelin;
